<template>
    <span class="ml-1">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-avatar 
                    class="audit" 
                    color="primary" 
                    :size="size" 
                    v-on="on"
                    @click="adrg2(table, encrid)">
                    <span :class="textClass">A</span>
                </v-avatar>
            </template>
            <span>{{ tooltip }}</span>
        </v-tooltip>
        <adrg2 ref="adrg2" />
    </span>
</template>

<script>
    import adrg2 from "@/components/adrg2.vue";

    export default{ 
        components: {
            adrg2,
        },    
        props: {
            table: {
                type: String,
                required: true,               
            },
            encrid: {
                type: String,
                required: false,               
            },  
            tooltip: {
                type: String,
                required: false,  
                default: "Audit",             
            },          
            size: {
                type: Number,
                required: false,
                default: 30,
            },
        },
        computed: {
            textClass() {
                if (this.size <= 25) {
                    return "white--text text-body-2 font-weight-bold";
                }
                return "white--text text-h6";
            },
        },
        data() {
            return {
            }
        },  
        methods: {
            adrg2(table, encrid) {
                if (encrid !== undefined) {
                    this.$refs.adrg2.openAudit(table, encrid);
                }
            },
        },
    }

</script>

<style scoped>
    .audit {
        cursor: pointer;
    }
</style>